import React, { useEffect } from "react"; 
import Slider from "react-slick";
import { useSelector, useDispatch } from "react-redux";
import { SurfaceCleanerProduct } from "../../../../Api/Api";
import Skeleton from "react-loading-skeleton";
import ProductCard from "../ProductCard/ProductCard";
import 'react-loading-skeleton/dist/skeleton.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SurfaceCleaner = ({ title, count, showSlider = true }) => {
  const dispatch = useDispatch();
  const skeletonarray = [1, 2, 3, 4, 5, 6];

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 3,
    autoplay: false,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    arrows: false,
    className: "center gapgiven",
    centerMode: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 768,  settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 600,  settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 480,  settings: { slidesToShow: 2, slidesToScroll: 1 } }
    ]
  };

  useEffect(() => {
    dispatch(SurfaceCleanerProduct());
  }, [dispatch]);

  const surfaceCleanerData = useSelector((state) => state.surfaceCleaner);
  const { products, loading, error } = surfaceCleanerData;

  let Descending;
  if (count === false) {
    Descending = products ? [...products].sort((a, b) => b.id - a.id) : [];
  } else {
    Descending = products || [];
  }

  const Products = { loading, error };
  const product = products;

  return (
    <>
      <div className="w-full mt-[1rem] flex flex-nowrap flex-col gap-4" id="surfaceCleaner">
        {title !== undefined ? (
          <div className="w-full font-bold pl-[8px]">
            {!Products.loading && product !== undefined ? (
              <h2 className="text-bold text-[18px] md:text-[24px] leading-[40px] item-center">
                {title}
              </h2>
            ) : (
              <Skeleton count={2} />
            )}
          </div>
        ) : null}

        {Products.loading && (
          <div className="flex justify-between flex-wrap gap-2">
            {skeletonarray.map((id) => (
              <Skeleton key={id} count={1} className="w-[200px] h-[300px]" />
            ))}
          </div>
        )}

        {!Products.loading && Products.error ? (
          <div>Error: {Products.error}</div>
        ) : null}

        {showSlider ? (
          <div className="slider-container">
            <Slider {...settings}>
              {!Products.loading && product !== undefined
                ? Descending.map((item, idx) => <ProductCard key={idx} val={item} />)
                : null}
            </Slider>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4   gap-4">
            {!Products.loading && product !== undefined
              ? Descending.map((item, idx) => <ProductCard key={idx} val={item} />)
              : null}
          </div>
        )}
      </div>
    </>
  );
};

export default SurfaceCleaner;